import axios from 'axios';
import * as actionTypes from './actionTypes';
import $ from 'jquery';

export const authStart = () =>{
    return{
        type: actionTypes.AUTH_START
    }
}

export const authSuccess = (token, username, displayname) =>{
    return{
        type: actionTypes.AUTH_SUCCESS,
        token: token,
        username: username, 
        displayname: displayname,
    }
}

export const authFail = error =>{
    return{
        type: actionTypes.AUTH_FAIL,
        error: error
    }
}

export const authLogout = () =>{
    localStorage.removeItem('token')
    return{
        type: actionTypes.AUTH_LOGOUT
    }
}
export const authLogin = (username, password) =>{
    return dispatch => {
        dispatch(authStart());
        axios.post(
            'http://3.34.193.205:8000/login/', 
            {username: username, 
            password: password}
        ).then(res => {
            const token = res.token; 
            const username = res.username;
            const displayname = res.displayname;
            localStorage.setItem('token', token);
            localStorage.setItem('username', username);
            localStorage.setItem('displayname', displayname);
            dispatch(authSuccess(token, username, displayname));
        })
        .catch(err => {
            dispatch(authFail(err))
        })
    }
}

export const authSignup = () =>{
    return dispatch => {
        dispatch(authStart());
        $.ajax({
            url:'http://13.124.5.10:8000/api/signup/',
            method: 'POST',
            data: {},
            success: function(res){
                const token = res.token; 
                const username = res.username;
                const displayname = res.displayname;
                localStorage.setItem('token', token)
                localStorage.setItem('username', username);
                localStorage.setItem('displayname', displayname);
                dispatch(authSuccess(token, username, displayname));
                const condition=res.condition;
                const post_no = res.post_no
                console.log(res)
                window.location.href='/posts/';
            },
            error: function(err){
            console.log('error!')
            dispatch(authFail(err))
            },
    })
}
}

export const authCheckState =()=>{
    return dispatch => {
        const token = localStorage.getItem('token');
        if (token === null){
            dispatch(authSignup());
        }else{
            const username=localStorage.getItem('username');
            const displayname=localStorage.getItem('displayname');
            dispatch(authSuccess(token, username, displayname));
        }
    }
}